import React, { useState, useEffect, useRef } from "react";
import Table from "../../Common/table";
import axios from "../../httpServices/httpService";
import api from "../../config.json";
import swal from "sweetalert";

import _, { cloneDeep, result } from "lodash";
import joi, { object } from "joi";
import Loading from "../../utill/LoadingComponent";
import { ToastContainer, toast } from "react-toastify";
import DateSelection from "../../Common/DateSelection";
import { Button, Modal, Select } from "antd";
// import 'antd/dist/antd.css';
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFile,
  faFilePdf,
  faMinusCircle,
  faPlusCircle,
  faThumbsDown,
  faThumbsUp,
} from "@fortawesome/free-solid-svg-icons";

import PaginationComponent from "../../Common/PaginationComponent";
import { generateExcelFile } from "../../utill/download";

const IssueRecords = ({
  handleDownloadTableToExcel,
  equips,
  equipGroups,
  fromDateLimit,
  Heading,
}) => {
  const reportType = [
   
  ];
  const [qualityData, setQualityData] = useState([]);
  const [inputData, setInputData] = useState({
    From: new Date(),
    Till: new Date(),
  });
  const [types, setAllTypes] = useState([]);
  const [sortColumn, setSortColumn] = useState({
    path: "ToolId",
    order: "asc",
  });



  const [loader, setLoader] = useState(false);
  const [CurrentPage, setCurrentPage] = useState(1);
  const [TotalPage, setTotalPage] = useState(0);
  const [PageSize, setPageSize] = useState(50);

  const customerRef = useRef(null);
  // const filteredOptions = clients.filter((o) => !selectedItems.find(b => o.label == b));

  useEffect(() => {
    Heading("Material Issue Record");
    GetAllInspetcionTypes();
  }, []);
    useEffect(() => {
      handleGetData();
    }, [CurrentPage, PageSize]);

  const handleOnChange = (name, value) => {
    const obj = { ...inputData };
    obj[name] = value;
    setInputData(obj);

  };
  const handleDownloadExcel = (e) => {
    generateExcelFile(e);
  };
  const handleGetData = async () => {
    try {
      setLoader(true); // Show loader before making the API call

      const result = await axios.post(`${api.api}TracebilityReport`, {
        ...{ query: "", PageSize: PageSize, Page: CurrentPage },
        ...inputData,
      });

      setLoader(false); // Hide loader after the API call

      if (result.data.data.length > 0) {
        console.log(result.data, "fjrgjbnkgj");
        setQualityData(result.data.data);
        setTotalPage(result.data.totalDocuments);
      } else {
        setQualityData([]); // Clear previous data
        swal("No Data Available");
      }
    } catch (err) {
      setLoader(false); // Ensure the loader is hidden on error
      console.error("Error fetching data:", err);

      if (err.response && err.response.data) {
        swal(err.response.data.message, { dangerMode: true });
      } else {
        swal("An unexpected error occurred.", { dangerMode: true });
      }
    }
  };
  
  const handleSort = (sortColumn) => {
    if (qualityData.length > 0) {
      const sorted = _.orderBy(
        qualityData,
        [sortColumn.path],
        [sortColumn.order]
      );
      setSortColumn(sortColumn);
      setQualityData(sorted);
    }
  };
 
 
  const columns1 = [
    {
      path: "MixingDate",
      label: "Mixing Date / Time",
      content: (obj) => <>{moment(obj.MixingDate).format("DD-MM-YY / hh:mm a")}</>,
    },
    {
      path: "ExpiryDate",
      label: "Useby Date / Time",

      content: (obj) => <>{moment(obj.ExpiryDate).format("DD-MM-YY / hh:mm a")}</>,
    },
    { path: "CompoundCode", label: "Compound Code" },
    { path: "BatchCode", label: "Batch Code" },
    { path: "NumOfStickers", label: "Num Of Stickers" },   
    { path: "TracebilityNo", label: "Traceability No" },
    { path: "Tc_No", label: "Test Certificate No" },

    { path: "Qty", label: "Qty" },
   
    // {
    //     key: "view",
    //     label: "View Report",
    //     content: (obj) => (
    //         <React.Fragment>
    //             <button className='btn btn-secondary' onClick={() => {
    //                 const part = allPartsCache.find((part) => part.ItemName == obj.BatchCode && part.ItemNumber == obj.ItemNumber )
    //                 if (part) {
    //                     const checkSheet = part.Inspection.find(x => x.InspectionName == obj.InspectionType)
    //                     const template = checkPointTemplates.find(x => checkSheet && checkSheet.checkSheetTitle && x.Name == checkSheet.checkSheetTitle.TemplateName)
    //                     template.Columns = template.Columns.filter(x => x.EnableForDataEntry)
    //                     setSelectedTemplate(template)
    //                 }
    //                 setReportData(obj);
    //                 setOpen(true)
    //             }}>
    //                 <FontAwesomeIcon icon={faFile} />
    //             </button>
    //         </React.Fragment>
    //     ),
    // },
  ];

  const GetAllInspetcionTypes = () => {
    axios
      .get(api.api + "AssetMaster")
      .then((result) => {
        const reports = [...reportType];
        result.data.forEach((one) => {
          const obj = {
            label: one.AssetId,
            value: one.AssetId,
            name: one.AssetId,
          };
          reports.push(obj);
        });
        setAllTypes(reports);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <React.Fragment>
      {loader ? <Loading labelShow={true} label={"Loading..."} /> : ""}

      <div className="row mx-2">
        <div className="col-sm-2">
          <div className="form-group">
            <label className="small m-0">From</label>
            <input
              value={moment(inputData.From).format("YYYY-MM-DD")}
              className="form-control form-control-sm"
              onChange={(e) => handleOnChange("From", e.currentTarget.value)}
              type="date"
            />
          </div>
        </div>
        <div className="col-sm-2">
          <div className="form-group">
            <label className="small m-0">Till</label>
            <input
              value={moment(inputData.Till).format("YYYY-MM-DD")}
              className="form-control form-control-sm"
              onChange={(e) => handleOnChange("Till", e.currentTarget.value)}
              type="date"
            />
          </div>
        </div>
        {/* <div className="col-sm-2">
          <label className="small text-center  m-0">Asset</label>
          <Select
            maxTagCount={"responsive"}
            mode="multiple"
            placeholder="Select Asset"
            value={inputData.Asset}
            onChange={(values) => {
              if (values.includes("All")) {
                if (inputData.Asset && inputData.Asset.length === types.length) {
                  handleOnChange("Asset", []);
                } else {
                  handleOnChange("Asset", ["All"]);
                }
              } else {
                // Update selected values normally
                handleOnChange("Asset", values);
              }
            }}
            style={{ width: "100%" }}
            options={[{ label: "All", value: "All" }, ...types]}
          />
        </div> */}

        <div className="col-sm-2 py-4">
          <button
            className="btn btn-primary btn-sm "
            onClick={() => handleGetData()}
          >
            Apply
          </button>
        </div>
        {qualityData && qualityData.length > 0 ?  <div className="col-sm-2 py-4">
            <button   onClick={() => handleDownloadExcel("MaterialIssueRecord")}className="btn-sm btn-primary ">Download  Report</button>
        </div>:''}
      </div>

      {qualityData.length > 0 ? (
        <Table
          id="MaterialIssueRecord"
          onSort={handleSort}
          columns={columns1}
          sortColumn={sortColumn}
          // data={extractInspectionDataSeparateArray(qualityData[0])}
        //   searchquery={true}
        //   handelSearch={handleGetData1}
          data={qualityData}
        />
      ) : (
        <Table
          id="RejectionDetailedAnalysispiechart"
          onSort={handleSort}
          columns={columns1}
          sortColumn={sortColumn}
          // data={extractInspectionDataSeparateArray(qualityData[0])}
        //   searchquery={true}
        //   handelSearch={handleGetData1}
          data={[]}
        />
      )}
      {qualityData && qualityData.length > 0 && (
        <div className="float-end m-3">
          <PaginationComponent
            defaultCurrent={CurrentPage}
            total={TotalPage}
            CurrentPageNumber={(currentpage, pagesize) => {
              setCurrentPage(currentpage);
              setPageSize(pagesize);
            }}
          />
        </div>
      )}
      {/* {qualityData.length > 0 && (
        <div className="float-end m-3">
          <PaginationComponent
            defaultCurrent={CurrentPage}
            total={TotalPage}
            CurrentPageNumber={(currentpage, pagesize) => {
              setCurrentPage(currentpage);
              setPageSize(pagesize);
            }}
          />
        </div>
      )} */}
    </React.Fragment>
  );
};
export default IssueRecords;
